<template lang="pug">
div.search-overlay(
    v-show="show"
    v-bind:style="style")

    search-option-input-text(
        ref="SearchInput"
        v-model="value"
        v-bind:on-enter="onEnter"
        v-bind:autofocus="true"
        v-bind:placeholder="$t('common.search')")

    icon-close(
        v-bind:title="$t('common.close')"
        v-on:click="onClose")

</template>

<script>
// import SearchOptionInputText from '@/components/SearchOptions/InputText';

export default {
    name: 'search-overlay',

    components: {
        // SearchOptionInputText
    },

    data: function () {
        return {
            show: false,
            style: '',
            value: {Text: ''}
        };
    },

    mounted: function () {
        this.style = this.getWrapperStyle();
        this.$eventBus.$on('show-search-overlay', this.onToggleShow);
    },

    beforeDestroy: function () {
        this.$eventBus.$off('show-search-overlay', this.onToggleShow);
    },

    watch: {
        /**
         * Set style and bind keycode listeners for esc key to close the overlay.
         */
        show: function () {
            this.style = this.getWrapperStyle();
            if (this.show) {
                document.addEventListener('keydown', this.onKeyDown);
            }
            else {
                document.removeEventListener('keydown', this.onKeyDown);
            }
        }
    },

    methods: {
        /**
         * Get search overlay style.
         * On tablet (navbar width >= 1024px), the search bar overlaps navbar, having same height.
         * On mobile (< 1024px) it will be beneath the logo (auto height).
         */
        getWrapperStyle: function () {
            const navbar = document.querySelector('.navbar.main-navigation');
            if (!navbar || !navbar.clientHeight || !navbar.clientWidth) {
                return '';
            }

            let style = '';
            if (navbar.clientWidth >= 1024) { // desktop or tablet
                style += `height: ${navbar.clientHeight}px;`;
            }

            return style;
        },

        onToggleShow: function (forceClose) {
            if (!this.show && !forceClose) {
                this.value = {Text: ''};
                this.show = true;
                this.$nextTick(() => {
                    this.$refs.SearchInput?.$el.querySelector('input')?.focus();
                });
            }
            else {
                this.show = false;
            }
        },

        onKeyDown: function (event) {
            if (event.keyCode === 27) {
                this.onClose();
            }
        },

        onEnter: function () {
            const text = (this.value && this.value.Text) || '';
            const query = {Text: text};
            this.onClose();
            this.$router.push({name: `${this.$i18n.locale}.Search`, query});
            // -> exits this view
        },

        onClose: function () {
            this.show = false;
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/variables';

.search-overlay {
    position: fixed;
    top: 100px;
    right: 0;
    left: 0;
    z-index: 15000; // above .dx-overlay-wrapper
    display: flex;
    width: auto;
    height: auto; // will be dynamically adjusted for desktop
    min-height: 5em;
    background-color: rgba(0, 0, 0, 0.90);
    transition-property: all;
    transition-duration: 500ms;
    transition-timing-function: ease-in;

    .search-input-text {
        position: relative;
        top: 1rem;
        max-width: 85vw;
        margin: 0 auto 0 1rem;
        .dx-textbox, input {
            background-color: $light-gray;
        }
    }

    .close-icon {
        position: absolute;
        top: 1rem;
        right: 1.5rem;
        width: 2rem;
        height: 2rem;
        color: $light-gray;
        cursor: pointer;
    }

    // dynamically adjust for tablet
    @media screen and (min-width: $breakpoint-tablet) {
        .search-input-text {
            max-width: 90vw;
            margin-left: 2rem;
        }
    }

    // dynamically adjust for desktop
    @media screen and (min-width: $breakpoint-desktop) {
        top: 0;
        left: calc(137px + 45px + 2rem); // logo width 137px + 45px margin
        min-height: unset;
        .search-input-text {
            top: 35px;
            max-width: 70vw;
        }
        .close-icon {
            top: 2rem;
            right: 3rem;
        }
    }
}
</style>
